<template>
  <div v-if="isInitial">
  <a id="isConfirmOrigin" @click="$emit('backToInput', inspection , pitlock)"></a>
    <div class="content-wrapper">
      <div class="container">
        <article>
          <div class="step-bar-container">
            <ul>
              <li class="li-step">
                <span class="stepnum num01"></span>
                <span class="steptext">条件入力</span>
              </li>
              <li class="li-step">
                <span class="stepnum num02"></span>
                <span class="steptext">見積り確認</span>
              </li>
              <li class="li-step">
                <span class="stepnum num03"></span>
                <span class="steptext">連絡先入力</span>
              </li>
              <li class="li-step active">
                <span class="stepnum num04"></span>
                <span class="steptext">最終確認</span>
              </li>
            </ul>
          </div>
          <div class="section white-panel mb2p pb8">
            <h2 class="fs16 mb8 color-red1">この時点ではお申し込みは完了していません</h2>
            <p class="fs13 color-font2">車両情報やお客様の情報が正しく入力されていることを確認してください。</p>
            <button class="button fs16 mt8 mb12" v-on:click="toCheckAgreementScroll()">お申し込みはこちら</button>
            <p class="text-center color-red1 fs16">※こちらは事前点検のお申し込みです。</p>
          </div>
          <section class="section white-panel pt20">
            <h2 class="fs16 mb4">見積り金額(税込)</h2>
            <div class="flex">
              <p class="flex1 fs24 mb12">{{ $filters.addComma(price.total) }}円</p>
            </div>
            <div class="bg-gray1 pd12 mb16">
            <dl class="dl estimate-result-list mb4">
              <dt class="fs16 font-weight-bold">法定費用</dt>
              <dd class="mb4 fs16 font-weight-bold color-font1">{{ $filters.addComma(price.legal_fee.subtotal) }} 円</dd>
              <dt class="list">重量税</dt>
              <dd>{{ $filters.addComma(price.legal_fee.weight_tax) }}円</dd>
              <dt class="list">自賠責保険24ヶ月</dt>
              <dd>{{ $filters.addComma(price.legal_fee.cali_fee) }}円</dd>
              <dt class="list">印紙代</dt>
              <dd class="mb12">{{ $filters.addComma(price.legal_fee.revenue_stamp_fee) }}円</dd>

              <dt class="fs16 font-weight-bold">車検＋整備費用</dt>
              <dd class="mb4 fs16 font-weight-bold color-font1">{{ $filters.addComma(price.price.subtotal) }} 円</dd>
              <dt class="list">定額整備部品の交換</dt>
              <dd class="color-green2 font-weight-bold">コミコミ！</dd>
              <dt class="list">整備保証・法定12ヶ月点検*</dt>
              <dd class="color-green2 font-weight-bold">コミコミ！</dd>
            </dl>
            <p class="fs11 pl5p pr5p">対象部品に異常がある場合は無償で交換・整備します
（半年間または走行距離1万kmに達した時点のいずれか短い期間が保証対象）
また、車検後の法定12ヶ月点検を無料で実施します</p>
            <dl class="dl estimate-result-list mb4" v-if="price.price.oil_exchanged_fee !== 0">
              <dt class="list">エンジンオイル交換不要</dt>
              <dd class="color-green2 font-weight-bold">{{ $filters.addComma(price.price.oil_exchanged_fee) }}円</dd>
            </dl>

            <dl class="dl estimate-result-list mb4" v-if="price.coupon_fee !== null">
                <dt class="fs16">クーポン</dt>
                <dd class="mb12 fs16">{{ $filters.addComma(price.coupon_fee) }}円</dd>
            </dl>
          </div>
          <p class="fs11 color-font2 mb0">※エコカーのお客様の場合、エコカー減税の適用により車検費用が変わる可能性があります。</p>

          <p class="fs11 color-font2 mb0">※整備中に追加で整備が必要な箇所が見つかり、それが<span class="color-green2">標準交換36部品</span>に含まれない場合は、上記の金額に追加の整備費がかかる場合があります。ご了承ください</p>

          <p class="fs11 color-font2">※バンパー、ドアミラー、フロントガラスなど定額対象外の整備が発生し追加の整備費用がかかることがあります。定額整備部品の一覧や交換基準は<a href="#" v-on:click="toAgreement()">こちら</a>をご覧ください。</p>
          </section>
          <section class="section white-panel pr0 pt12">
            <hr class="hr-solid-gray mb20">
            <h2 class="fs16 font-weight-bold">車両情報</h2>
            <table class="table w100p fs14">
              <tbody>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12 w30p">車検満了日</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ expiryOnWareki.gengo }}{{ $filters.checkFirstYear(expiryOnWareki.year) }}年{{ expiryOnWareki.month }}月{{ expiryOnWareki.date }}日</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">初度登録年月</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ firstRegistrationOnWareki.gengo }}{{ $filters.checkFirstYear(firstRegistrationOnWareki.year) }}年{{ firstRegistrationOnWareki.month }}月</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">自動車種別</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ carType.name }}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">車名(メーカー)</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ Manufacturer.manufacturer_name }}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">車両重量</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ $filters.addComma(car.weight) }}kg</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">走行距離</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ this.mileageWordSet(car.mileage)}}</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section class="section white-panel pr0 pt12">
            <h2 class="fs16 font-weight-bold">予約情報</h2>
            <table class="table w100p fs14">
              <tbody>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12 w30p">予約日時</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p" v-if="pitlock.start_at">{{ userForYyyyMmDD }} {{ pitlockSlots.time.information.reception_hour }}</td>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p" v-if="!pitlock.start_at">後日店舗からの電話にて承ります</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section class="section white-panel pr0 pt12">
            <h2 class="fs16 font-weight-bold">お客様情報</h2>
            <table class="table w100p fs14">
              <tbody>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12 w30p">お名前</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p disable-auto-tel">{{ pitlock.last_name }} {{pitlock.first_name}}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12 w30p">電話番号</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p disable-auto-tel">{{ inspection.tel }}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">備考</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p pre-wrap">{{ inspection.user_request }}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">代車利用</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p" v-if="inspection.replacement_vehicle_requested === 'true'">必要</td>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p" v-if="inspection.replacement_vehicle_requested === 'false'">不要</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section class="section white-panel pr0 pt12 pb0">
            <h2 class="fs16 font-weight-bold">車検実施店舗</h2>
            <table class="table w100p fs14">
              <tbody>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12 w30p">店舗名</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ ssInfo.ss_name }}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">電話番号</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p disable-auto-tel">{{ ssInfo.tel }}</td>
                </tr>
              </tbody>
            </table>
          </section>
          <div class="section white-panel pr0 pt12 pb0 mb12">
            <h2 class="fs16 font-weight-bold">確認・同意事項</h2>
            <table class="table w100p fs14">
              <tbody>
                <tr>
                  <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                    こちらの<a v-on:click="toAgreement()" class="color-green2">利用規約</a>
                    <label class="pr44">
                      に同意します
                      <input type="checkbox" name="" value="" class="checkbox-input1" v-model="agreement.matter1">
                      <span class="checkbox-area1"></span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                    <label class="pr44">
                      以下の注意事項について了承します
                      <input type="checkbox" name="" value="" class="checkbox-input1" v-model="agreement.matter2">
                      <span class="checkbox-area1"></span>
                    </label>
                  </td>
                </tr>
                <ul class="fs12 color-green2 line-height1_7 mt12 mr20 ml20 mb22 ul-disc">
                  <li><span class="color-font1">自動車税の滞納がないことをご確認ください</span></li>
                  <li><span class="color-font1">放置違反金（駐車違反の罰金等）がある方は納付を済ませてください</span></li>
                  <li><span class="color-font1">車両に違法・不正改造している車はお受付できません</span></li>
                  <li><span class="color-font1">メーカーやディーラーからのリコールを受けていて未回収の場合は車検証を発行できない場合があります</span></li>
                  <li><span class="color-font1">ホイールに盗難防止ナットをご利用の場合は、キーアダプターをご持参ください</span></li>
                </ul>
              </tbody>
            </table>
          <div class="section transparent-panel">
            <p class="mb0 pb14 text-center error">{{form.agreementErrorMessage}}</p>
            <button v-bind:disabled="processing" @click="$emit('toCompleteCheck', agreement, form)" class="button fs16 mt8 mb28 mr14 ml14 pd16" id="confirmation">店舗に申し込みをする</button>
          </div>
          </div>
        </article>
      </div>
    </div>
  </div>
  <div v-else-if="isAgreement">
    <a id="isAgreement" v-on:click="toInitial()"></a>
    <Agreement></Agreement>
  </div>
</template>

<script>
import Agreement from '@/views/v2/Agreement.vue'
import moment from 'moment'

const IS_INITIAL = 'IS_INITIAL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data: () => ({
    currentState: IS_INITIAL,
    agreement: {
      matter1: false,
      matter2: false
    },
    form: {
      agreementErrorMessage: ''
    }
  }),
  computed: {
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    },
    userForYyyyMmDD () {
      if (!this.pitlockCalendar.day.information.dayYyyyMmdd) return null
      return moment(this.pitlockCalendar.day.information.dayYyyyMmdd).format('YYYY年MM月DD日')
    }
  },
  methods: {
    toInitial () {
      this.currentState = IS_INITIAL
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.nativeEVENTSet('ShakenKakuninButton', 'MOVED_SHAKEN_RIYOUKIYAKU', 'TAP')
      window.scrollTo(0, 0)
    },
    toCheckAgreementScroll () {
      this.$SmoothScroll(
        document.querySelector('#confirmation'),
        500,
        null,
        null,
        'y'
      )
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    this.nativePVset('SHAKEN_KAKUNIN')
  },
  props: [
    'pitlock',
    'inspection',
    'car',
    'price',
    'expiryOnWareki',
    'firstRegistrationOnWareki',
    'carType',
    'Manufacturer',
    'ssInfo',
    'processing',
    'pitlockCalendar',
    'pitlockSlots'
  ],
  components: {
    Agreement
  }
}
</script>
